import { graphql } from '~/graphql';
import { useGraphqlQuery } from '~/hooks/useGraphqlQuery';

export const useGetSellerInventoryProductLengthsByPlatformProduct = (
  platformProductId: string
) => {
  const sellerInventoryProductLengthsByPlatformProductQuery = graphql(`
    query sellerInventoryProductLengthsByPlatformProduct(
      $platformProductId: ID!
    ) {
      sellerInventoryProductLengthsByPlatformProduct(
        platformProductId: $platformProductId
      ) {
        id
        length {
          actualLengthInches
          nominalLengthInches
          displayValue
        }
        platformProduct {
          id
          name
        }
        latestPriceMax
        latestPriceMin
        latestPriceMid
      }
    }
  `);

  return useGraphqlQuery(
    sellerInventoryProductLengthsByPlatformProductQuery,
    ['sellerInventoryProductLengths', platformProductId],
    { platformProductId }
  );
};
